export default __webpack_public_path__ + "static/media/sticker-3.5ab718d7.png";